import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-style-five',
  templateUrl: './features-style-five.component.html',
  styleUrls: ['./features-style-five.component.scss']
})
export class FeaturesStyleFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
